import { useQueryParamValue } from 'src/app/shared/hooks/location';
import { useSession } from 'src/app/shared/hooks/session';

import { useAvailablePaymentMethods } from '../../../../../formContext/availablePaymentMethodsContext';
import { usePromoteFormData } from '../../../../../formContext/formData';
import { usePromoteFormState } from '../../../../../formContext/formState';
import { useMemoizedProperties } from '../useMemoizedProperties';

type Properties = Record<string, string | boolean | number | readonly string[] | readonly number[] | undefined>;

export function useTrackingProperties(): Properties {
	const [{ amount, isPublic, paymentMethodSaveOptions }] = usePromoteFormState();
	// usingSavedPaymentMethod is always false in PSF (not supported)
	const usingSavedPaymentMethod = false;

	const { amountChoices, currency, petition, promotionSettings, user } = usePromoteFormData();
	const { paymentMethods } = useAvailablePaymentMethods();

	const memoizedProperties = useMemoizedProperties();

	// banditTrackingProperties skipped - bandits not available in formData

	const session = useSession();
	const sourceLocation = useQueryParamValue('source_location');
	const currentSource = useQueryParamValue('utm_source') || session.trackingData.current_source;

	return {
		cpm: promotionSettings.cpm,
		bonus_cpm: promotionSettings.bonusCpm ?? undefined,
		currency: currency.code,
		current_source: currentSource,
		custom_amount: !amountChoices.some((choice) => choice.amount === amount),
		exchange_rate: currency.exchangeRate,
		local_amount: amount,
		own_petition: petition.user.id === user.id,
		petition_id: `petition_${petition.id}`,
		product_flow: 'promoted',
		promote_transaction: 'single',
		public: isPublic,
		save_payment_method: paymentMethodSaveOptions.shouldSavePaymentMethod,
		source_location: sourceLocation,
		use_saved_payment_method: usingSavedPaymentMethod,
		// categoryTags not available in formData
		// geoReach and relevantLocationLocalizedName not available in formData
		visible_payment_types: paymentMethods,
		// banditTrackingProperties skipped
		...memoizedProperties,
	};
}
